var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressureLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5742 23.4318C29.1084 21.0788 30 18.2685 30 15.25C30 6.96573 23.2843 0.25 15 0.25C11.6004 0.25 8.46496 1.38094 5.94936 3.28711L7.85697 4.73185C9.89504 3.35194 12.3534 2.54596 15 2.54596C22.0453 2.54596 27.7566 8.25727 27.7566 15.3025C27.7566 17.7571 27.0634 20.0497 25.862 21.9953H4.13808C2.93671 20.0497 2.24347 17.7571 2.24347 15.3025C2.24347 12.8567 2.93179 10.5717 4.12527 8.63052L2.67092 6.70401C0.98697 9.12882 0 12.0742 0 15.25C0 18.2685 0.891608 21.0788 2.42583 23.4318C2.76937 23.9587 3.36899 24.25 3.998 24.25H26.002C26.631 24.25 27.2306 23.9587 27.5742 23.4318Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2604 13.4271C18.508 14.6746 18.508 16.6973 17.2604 17.9449C16.0129 19.1924 13.9902 19.1924 12.7426 17.9449C11.495 16.6973 4.25732 4.94177 4.25732 4.94177C4.25732 4.94177 16.0129 12.1795 17.2604 13.4271Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureLow);
export default __webpack_public_path__ + "static/media/pressure_low.7c1549987d201325531afb43d8c1ec91.svg";
export { ForwardRef as ReactComponent };